// components/DashboardHome.js
import React, { useState, useEffect } from 'react';
import { 
  UsersIcon, 
  ChartBarIcon, 
  DocumentTextIcon,
  ClockIcon,
  CalendarIcon,
  VideoCameraIcon,
  EyeIcon,
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
  ArrowPathIcon 
} from '@heroicons/react/24/outline';
import { ToastContainer, toast } from 'react-toastify';
import AlertDesign from './AlertDesign.jsx';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../../baseurl.js';
axios.defaults.baseURL = baseUrl;

const DashboardHome = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalSessions: 0,
    todaySessions: 0,
    upcomingSessions: 0
  });
  const [todaySessions, setTodaySessions] = useState([]);
  const [upcomingSessions, setUpcomingSessions] = useState([]);
  const [sessionChartData, setSessionChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [found, setFound] = useState(null);
  const [expireDate, setExpireDate] = useState('');
  const [userLimit, setUserLimit] = useState(0);
  const [v, setV] = useState(null);
  const [updateVersion, setUpdateVersion] = useState(null);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const admin_info = localStorage.getItem("relay_server_info");
  let admin_data = "";
  if(admin_info != "undefined")
    {
      admin_data = JSON.parse(admin_info);
    } 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clLimit, setClLimit] = useState(0);
  const [expiry, setExpiry] = useState(null);
  const [lastSync, setLastSync] = useState('');
  //console.log(admin_info);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  useEffect(() => {
    loadDashboardData();
    autoDeleteChat();
    checkSystemDate();
    
    

  }, []);

  useEffect(()=>{
    getPlan();
    
  }, [loadingBtn]);

  useEffect(() => {
  if (v) { 
    checkUpdate();
  }
}, [v]);


   // Close modal with Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    if (isModalOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);



  const checkUpdate = async ()=>{
    //console.log(v);
    try{
          const res = await axios.post('https://workspace.vsatx.in/api/check-update',{
            version: v,
            email: admin_data.email
          });

          if(res.data.success)
          {
            //console.log(res.data.data);
            setUpdateVersion(res.data.data);
            setUpdateBtn(true);
            
          }
    }
    catch(error)
    {
        console.error("Error:", error.response?.data || error.message);
    }
  }

  const getPlan = async ()=>{
    const token = localStorage.getItem("relay_server_token");
    try{
          const res = await axios.get('admin/get-plan',{
              headers: {
              Authorization: `Bearer ${token}`,
            }
          });

          if(res.data.success)
          {
            console.log(res.data.plan);
            const planVersion = res.data.plan.version;
            setExpireDate(res.data.plan.expire_date);
            setUserLimit(res.data.plan.user_limit);
            setV(planVersion);
            setLastSync(res.data.plan.updatedAt);

            checkUpdate(planVersion);
            
          }
    }
    catch(error)
    {
        console.error("Error:", error.response?.data || error.message);
    }
  }

  const checkSystemDate = async () => {
    const today = new Date().toISOString().split('T')[0];
    const token = localStorage.getItem("relay_server_token");

    if (!token) {
      console.warn("No token found in localStorage!");
      return;
    }

   

    try {
      const res = await axios.post(
        "/admin/check-date",
        { today },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (res.data.success) {
        setFound(res.data.update);
        
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }

  };


  const loadDashboardData = async () => {
    try {
      const token = localStorage.getItem("relay_server_token");
      const today = new Date().toISOString().split('T')[0];
      // Load all data in parallel
      const [statsRes, todayRes, upcomingRes, chartRes] = await Promise.all([
        axios.get('admin/dashboard-stats', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`admin/get-studio/${today}`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get('admin/upcoming-sessions', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get('admin/session-chart-data', {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      // Set stats
      if (statsRes.data.success) {
        setStats(statsRes.data.stats);
      }

      // Set today's sessions
      if (todayRes.data.success) {
        setTodaySessions(todayRes.data.studio || []);
      }

      // Set upcoming sessions
      if (upcomingRes.data.success) {
        setUpcomingSessions(upcomingRes.data.sessions || []);
      }

      // Set chart data
      if (chartRes.data.success) {
        setSessionChartData(chartRes.data.chartData || []);
      }

    } catch (error) {
      toast.error('Error loading dashboard data');
      console.error('Dashboard error:', error);
    } finally {
      setLoading(false);
    }
  };

  const autoDeleteChat = async () => {
    try {
      const token = localStorage.getItem("relay_server_token");
           
      const res = await  axios.get('admin/auto-delete-chats', {
          headers: { Authorization: `Bearer ${token}` }
        })
      


    } catch (error) {
    } finally {
      
    }
  };



  const StatCard = ({ title, value, icon: Icon, trend, description }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-2">{value}</p>
          {description && (
            <p className="text-xs text-gray-500 mt-1">{description}</p>
          )}
        </div>
        <div className={`p-3 rounded-lg ${getIconBgColor(Icon)}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
      {trend && (
        <div className={`flex items-center mt-3 text-sm ${trend.value > 0 ? 'text-green-600' : 'text-red-600'}`}>
          {trend.value > 0 ? (
            <ArrowTrendingUpIcon className="w-4 h-4 mr-1" />
          ) : (
            <ArrowTrendingDownIcon className="w-4 h-4 mr-1" />
          )}
          <span>{Math.abs(trend.value)}% {trend.label}</span>
        </div>
      )}
    </div>
  );

  const getIconBgColor = (Icon) => {
    const colors = {
      UsersIcon: 'bg-blue-500',
      VideoCameraIcon: 'bg-purple-500',
      CalendarIcon: 'bg-green-500',
      ClockIcon: 'bg-orange-500',
      ChartBarIcon: 'bg-indigo-500',
      DocumentTextIcon: 'bg-pink-500'
    };
    return colors[Icon.name] || 'bg-gray-500';
  };

  const formatTime = (time) => {
    if (!time) return 'N/A';
    return new Date(`2000-01-01T${time}`).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return 'Tomorrow';
    } else {
      return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      });
    }
  };

  const SessionCard = ({ session, isToday = false }) => (
    <div className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h4 className="font-semibold text-gray-900 text-sm">{session.studio_name}</h4>
          <p className="text-xs text-gray-600 mt-1 line-clamp-2">{session.description}</p>
          <div className="flex items-center mt-2 text-xs text-gray-500">
            <ClockIcon className="w-3 h-3 mr-1" />
            <span>{formatTime(session.start_time)} - {formatTime(session.end_time)}</span>
          </div>
        </div>
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
          isToday ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
        }`}>
          {isToday ? 'Today' : formatDate(session.date)}
        </div>
      </div>
    </div>
  );

  const SessionChart = () => {
    // Simple bar chart component
    const maxSessions = Math.max(...sessionChartData.map(item => item.sessions), 1);
    
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Sessions Overview</h3>
          <ChartBarIcon className="w-5 h-5 text-gray-400" />
        </div>
        
        <div className="space-y-4">
          {sessionChartData.map((item, index) => (
            <div key={index} className="flex items-center">
              <div className="w-20 text-sm text-gray-600 font-medium">
                {item.label}
              </div>
              <div className="flex-1 ml-4">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-gray-500">{item.sessions} sessions</span>
                  <span className="text-xs font-medium text-gray-700">{item.percentage}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-gradient-to-r from-blue-500 to-purple-600 h-2 rounded-full transition-all duration-500"
                    style={{ width: `${(item.sessions / maxSessions) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {sessionChartData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No session data available
          </div>
        )}
      </div>
    );
  };


  // Close modal when clicking outside
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };


  const UpdateModal = () => {
    if (!isModalOpen) return null;

    return (
      <div 
        className="fixed w-full py-8 flex justify-center items-center z-50"
        onClick={handleBackdropClick}
      >
        <div className="bg-slate-300 rounded-lg mt-32 px-8 py-12 max-w-md w-full mx-4 relative shadow-xl">
          {/* Close Button */}
          <button
            onClick={closeModal}
            className="absolute top-4 pb-1 right-4 text-gray-600 hover:text-gray-900 text-2xl font-bold bg-gray-100 hover:bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center transition-colors"
          >
            ×
          </button>
          
          {/* Modal Content */}
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Update Available!</h3>
            <p className="text-gray-600 mb-6">A new version is available for download.</p>
            <div className="flex flex-col space-y-4">
              <a 
                href={updateVersion ? "https://edvsat.eduvsat.in/public/storage/"+updateVersion.path : '#'} 
                className="bg-blue-500 hover:bg-blue-600 text-white text-center py-3 px-4 rounded transition-colors duration-200 font-medium"
                download
              >
                Download Software
              </a>
              <a 
                href={updateVersion ? "https://edvsat.eduvsat.in/public/storage/"+updateVersion.license_path : '#'}
                className="bg-green-500 hover:bg-green-600 text-white text-center py-3 px-4 rounded transition-colors duration-200 font-medium"
                download
              >
                Download License
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const UpdatePlan = async (u_limit, expriry_new)=>{
    const token = localStorage.getItem("relay_server_token");
    try{
          const res = await axios.post('admin/update-plan',{
            user_limit: u_limit,
            expiry_date: expriry_new
          },{
              headers: {
              Authorization: `Bearer ${token}`,
            }
          });

          if(res.data.success)
          {
            console.log("update");
            
          }
    }
    catch(error)
    {
        console.error("Error:", error.response?.data || error.message);
    }
  }

  const getSyncData = async() => {
     setLoadingBtn(true);
      try{
      const res = await axios.post('https://workspace.vsatx.in/api/syn-details',{
        email: admin_data.email
      });

      if(res.data.success)
      {
        console.log(res.data.data);
        setClLimit(res.data.data.user_limit);
        setExpiry(res.data.data.expiry_date);
        UpdatePlan(res.data.data.user_limit, res.data.data.expiry_date);
        
      }
    }
    
    catch(error)
    {
        console.error("Error:", error.response?.data || error.message);
    }
     setLoadingBtn(false);
    
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (found === "expired" || found === true) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <div className="space-y-6">
      
      <ToastContainer position="top-right" autoClose={3000} />
      {
        found ? <AlertDesign message= "System Date munipute found ! please correct this date otherwise your software stop after 1 hours !"
          type="error" />:''
      }
      
      
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
        <UpdateModal/>
        <div className='flex items-center'>
          
          <p className='mr-3 p-1 border rounded px-2'>Last Sync : 
            {
              new Date(lastSync).toLocaleDateString()
            }

            </p>
          <button 
            onClick={getSyncData}
            disabled={loadingBtn}
            className="bg-pink-500 hover:bg-pink-700  text-white font-bold py-1 px-4 rounded transition-colors"
            title="Click To Sync Classroom Limit and software Expiry"
          >
            {
              loadingBtn ? "Wait...":<div className='flex justify-between items-center'><ArrowPathIcon className="h-4 w-4 text-white" />Sync</div>
            }
            
          </button>
          
        </div>
        <div className="flex items-center space-x-2 text-sm text-gray-500 mt-2 sm:mt-0">
          {updateBtn && (
            <button 
              onClick={openModal}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors"
              title="Click To Download"
            >
              Update Available
            </button>
          )}

          
          <CalendarIcon className="w-4 h-4" />
          <span>{new Date().toLocaleDateString('en-US', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</span>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <StatCard
          title="Total ClassRooms"
          value={stats.totalUsers}
          icon={UsersIcon}
          trend={{ value: 12, label: 'from last month' }}
        />
        <StatCard
          title="Total Sessions"
          value={stats.totalSessions}
          icon={VideoCameraIcon}
          trend={{ value: 8, label: 'from last week' }}
        />
        <StatCard
          title="Today's Sessions"
          value={stats.todaySessions}
          icon={CalendarIcon}
          description={`${todaySessions.length} scheduled`}
        />
        <StatCard
          title="Upcoming Sessions"
          value={stats.upcomingSessions}
          icon={ClockIcon}
          description="Next 7 days"
        />
        <StatCard
          title="ClassRoom Limits"
          value={userLimit}
          icon={ClockIcon}
          description="Total ClassRoom Limit"
        />
        <StatCard
          title="Expiry At"
          value={expireDate ? new Date(expireDate).toLocaleDateString() : new Date().toLocaleDateString()}
          icon={ClockIcon}
          description="Admin Software Expiry at"
        />
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Today's Sessions */}
        <div className="lg:col-span-2 space-y-6">
          {/* Today's Sessions */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Today's Sessions</h3>
              <div className="flex items-center space-x-2">
                <CalendarIcon className="w-5 h-5 text-gray-400" />
                <span className="text-sm text-gray-500">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                </span>
              </div>
            </div>
            
            <div className="space-y-3">
              {todaySessions.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <VideoCameraIcon className="w-12 h-12 mx-auto text-gray-300 mb-3" />
                  <p>No sessions scheduled for today</p>
                </div>
              ) : (
                todaySessions.map((session, index) => (
                  <SessionCard key={session._id || index} session={session} isToday={true} />
                ))
              )}
            </div>
          </div>

          {/* Upcoming Sessions */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Upcoming Sessions</h3>
              <ClockIcon className="w-5 h-5 text-gray-400" />
            </div>
            
            <div className="space-y-3">
              {upcomingSessions.length === 0 ? (
                <div className="text-center py-4 text-gray-500">
                  <p>No upcoming sessions</p>
                </div>
              ) : (
                upcomingSessions.slice(0, 5).map((session, index) => (
                  <SessionCard key={session._id || index} session={session} />
                ))
              )}
              
              {upcomingSessions.length > 5 && (
                <button className="w-full text-center text-blue-600 hover:text-blue-700 text-sm font-medium py-2">
                  View all {upcomingSessions.length} sessions
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="space-y-6">
          {/* Sessions Chart */}
          <SessionChart />

          {/* Quick Actions */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
            <div className="space-y-3">
              <button className="w-full flex items-center justify-between p-3 text-left bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors">
                <div className="flex items-center">
                  <PlusIcon className="w-5 h-5 text-blue-600 mr-3" />
                  <span className="text-sm font-medium text-blue-700">Add New Session</span>
                </div>
                <ArrowTrendingUpIcon className="w-4 h-4 text-blue-600" />
              </button>
              
              <button className="w-full flex items-center justify-between p-3 text-left bg-green-50 hover:bg-green-100 rounded-lg transition-colors">
                <div className="flex items-center">
                  <UsersIcon className="w-5 h-5 text-green-600 mr-3" />
                  <span className="text-sm font-medium text-green-700">Manage Users</span>
                </div>
                <ArrowTrendingUpIcon className="w-4 h-4 text-green-600" />
              </button>
              
              <button className="w-full flex items-center justify-between p-3 text-left bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors">
                <div className="flex items-center">
                  <ChartBarIcon className="w-5 h-5 text-purple-600 mr-3" />
                  <span className="text-sm font-medium text-purple-700">View Reports</span>
                </div>
                <ArrowTrendingUpIcon className="w-4 h-4 text-purple-600" />
              </button>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Activity</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-green-500 rounded-full mt-2"></div>
                <div>
                  <p className="text-sm font-medium text-gray-900">New session created</p>
                  <p className="text-xs text-gray-500">Studio A - 2 hours ago</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                <div>
                  <p className="text-sm font-medium text-gray-900">User registered</p>
                  <p className="text-xs text-gray-500">John Doe - 4 hours ago</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                <div>
                  <p className="text-sm font-medium text-gray-900">Session updated</p>
                  <p className="text-xs text-gray-500">Studio B - 6 hours ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Add missing icon component
const PlusIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

export default DashboardHome;